export default "__VITE_ASSET__eA9VY3C5__"